import { PricingManagement } from './PricingManagement.component';

export const Pricing = () => {
  return (
    <div>
      <PricingManagement />
    </div>
  );
};
